module.exports = __webpack_public_path__ + "static/media/tiktok.c985d17a.png";